import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpLoadingProgressService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private activeRequests = 0;
  private loadingTimer: Subscription | undefined;
  private readonly DEBOUNCE_TIME = 2000; // 2 seconds

  public loading$: Observable<boolean> = this.loadingSubject.asObservable();

  startLoading(): void {
    this.activeRequests++;

    if (this.activeRequests === 1) {
      // Start the debounce timer only for the first request
      this.loadingTimer = timer(this.DEBOUNCE_TIME).subscribe(() => {
        if (this.activeRequests > 0) {
          this.loadingSubject.next(true);
        }
      });
    }
  }

  stopLoading(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }

    if (this.activeRequests === 0) {
      // Clear the timer and hide loading immediately when all requests are done
      if (this.loadingTimer) {
        this.loadingTimer.unsubscribe();
        this.loadingTimer = undefined;
      }
      this.loadingSubject.next(false);
    }
  }
}
